import styled, { css } from 'styled-components'
import { Box } from 'reflexbox/styled-components'

import ChevronLeftIcon from 'components/Icons/ChevronLeft'
import ChevronRightIcon from 'components/Icons/ChevronRight'

export const Label = styled.label(
  ({ theme, focused, disabled, error }) => css`
    position: absolute;
    left: 24px;
    top: -8px;
    z-index: 10;

    background-color: #fff;
    color: ${disabled ? theme.colors.grays.N300 : theme.colors.grays.N500};
    padding: 0 8px;
    text-transform: uppercase;
    font-size: ${theme.fontSizes.label};
    font-weight: ${theme.fontWeights.extraBold};

    transition: color 0.2s;

    ${focused &&
      css`
        color: ${theme.colors.primary};
      `}
    ${error &&
      css`
        color: ${theme.colors.error};
      `}
  `,
)

export const PrevIcon = styled(ChevronLeftIcon)`
  position: absolute;
  left: 22px;
  top: 20px;
`

export const NextIcon = styled(ChevronRightIcon)`
  position: absolute;
  right: 22px;
  top: 20px;
`

export const Container = styled(Box)(
  ({ theme, focused, error }) => css`
    position: relative;
    display: flex;
    flex-direction: column;

    .CalendarDay__today {
      border: 2px solid ${theme.colors.primary};
    }

    .CalendarDay__selected {
      background: ${theme.colors.turquoises.T600};
    }

    .DateRangePickerInput {
      border-radius: 8px;
      border-color: ${focused ? theme.colors.primary : theme.colors.grays.N500};
      color: ${focused ? theme.colors.primary : theme.colors.grays.N500};
      display: flex;
      justify-content: space-between;
      align-items: center;
      ${focused &&
        css`
          box-shadow: ${theme.shadows.under[1]};
        `};
      ${error &&
        css`
          border-color: ${theme.colors.error};
        `}
    }

    .DateRangePickerInput_arrow_svg path {
      fill: ${focused ? theme.colors.primary : theme.colors.grays.N500};
    }

    .DateRangePickerInput_clearDates_default:hover {
      background-color: transparent;
    }

    .DateInput {
      background-color: transparent;
    }

    .DateInput_input {
      font-family: ${theme.fonts.body};
      font-size: ${theme.fontSizes.body};
      border: none;
      background-color: transparent;
    }

    .DateRangePickerInput__disabled {
      background-color: transparent;
      border-color: ${theme.colors.grays.N300};
    }

    .DateInput_input__disabled {
      color: ${theme.colors.grays.N300};
    }

    .DateRangePickerInput__disabled {
      .DateRangePickerInput_arrow svg path {
        fill: ${theme.colors.grays.N300};
      }

      .DateRangePickerInput_calendarIcon {
        cursor: not-allowed;
        svg path {
          fill: ${theme.colors.grays.N300};
        }
      }
    }

    .DateRangePickerInput_calendarIcon_svg path {
      fill: ${focused ? theme.colors.primary : theme.colors.grays.N500};
    }

    .DateRangePickerInput_arrow svg path {
      fill: ${focused ? theme.colors.primary : theme.colors.grays.N500};
    }

    .DateInput_fang {
      left: 145px;
    }

    .DateInput_fangStroke {
      stroke: ${theme.colors.primary};
    }

    .DayPicker__withBorder {
      box-shadow: 0 0 0 1px ${theme.colors.primary}, ${theme.shadows.under[1]};
      border-radius: 8px;
      overflow: hidden;
    }
  `,
)

export const ErrorText = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.error};
    font-size: ${theme.fontSizes[0]};
    line-height: 1em;
    position: absolute;
    bottom: -18px;
  `,
)
